export default __webpack_public_path__ + "static/media/Inter_18pt-Regular.86c330c6.ttf";